import styled from 'styled-components'

export const SharedLayoutWrapper = styled.main`
  width: 100vw;
  background-color: #ffffff;
  padding: 1.5rem;
  /* position: relative; */
`
